import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components';
import { DisplayUtils } from '../../utils';
import ContentLayout from '../../layouts/contentLayout/ContentLayout';
import './Legal.scss';

const Legal = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <div className="Legal">
        <div className="w-100 d-flex justify-content-center">
          {!DisplayUtils.isMobile() ? (
            <img src="/misc/icons/complete_logo_white.svg" alt="shop-icon" className="Legal__logo" />
          ) : (
            <div className="Legal__title">
              <Button
                icon="/misc/icons/arrow-left-blue.svg"
                action={() => history.goBack()}
                className="Button__transparent p-2 button-only-icon me-2"
                a11y={t('Globals.return')}
              />
              <h1>{t('Legal.head')}</h1>
            </div>
          )}
        </div>
        <div className="w-100 d-flex justify-content-center">
          <div className="Legal__container">
            {!DisplayUtils.isMobile() && (
              <div className="Legal__container__title">
                <Button
                  icon="/misc/icons/arrow-left-pink.svg"
                  action={() => history.goBack()}
                  className="Button__transparent p-2 button-only-icon me-2"
                  a11y={t('Globals.return')}
                />
                <h1>{t('Legal.head')}</h1>
              </div>
            )}
            <div className='Legal__container__content'>
              <div dangerouslySetInnerHTML={{ __html: t('Legal.info') }} className="Legal__container__content__description" />
            </div>
          </div>
        </div>
      </div>
    </ContentLayout>
  );
};

export default Legal;
